'use strict';

module.exports = {
    LANG: 'ru-ru',
    SIGN: 'Войдите',
    REGISTER: 'Регистрация',
    QUICK_ACCESS: 'Быстрый доступ с',
    SIGN_JOIN: 'Войдите или зарегистрируйтесь!',
    NOT_MEMBER: 'Не зарегистрированы?',
    ALREADY_MEMBER: 'Уже зарегистрированы?',
    SHOW_ALL: 'Показать все',
    HIDE: 'Скрыть'
};